import styled from 'styled-components'
import { colors } from 'styles/colors'
import { Container } from 'react-grid-system'

import bgLineLeft from 'assets/svg/bg-line-left.svg'
import bgLineRight from 'assets/svg/bg-line-right.svg'
import { mobile } from '../../styles/responsive'

export const Products = styled.div`
    background-image: url('${bgLineRight}');
    background-repeat: no-repeat;
    background-position: right 0 top 88px;
    background-size: auto;

    ${({ $main }) =>
        $main &&
        `
        background-image: url('${bgLineLeft}'), url('${bgLineRight}');
        background-repeat: no-repeat, no-repeat;
        background-position: left 115px top 0, right 0 top 88px;
        background-size: auto, auto;


    `}

    @media (max-width: 1200px) {
        background: none;
    }
`

export const Line = styled.div`
    background-color: #00ab85;
    height: 2px;
    z-index: -1;
    width: 447px;
    position: relative;
    top: 88px;

    @media (max-width: 1200px) {
        background: none;
    }
`

export const Error = styled.div`
    font-weight: 600;
    color: ${colors.purple};
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    width: auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    span {
        text-transform: uppercase;
        font-size: 24px;
        display: block;
        margin-bottom: 20px;
    }

    ${({ $mobile }) =>
        $mobile &&
        `
        top: 10%;
        transform: translate(-50%, -50%);
    `}
`

export const Button = styled.button`
    background-color: ${colors.purple};
    color: #fff;
    font-weight: 600;
    border-radius: 5px;
    padding: 15px 30px;
    border: none;
    text-transform: uppercase;
    font-size: 13px;
    cursor: pointer;
    transition: all 150ms;

    &:hover {
        box-shadow: 0 0 5px 3px lighten(${colors.purple}, 50%);
    }

    &:active {
        background-color: darken(${colors.purple}, 5%);
    }

    &:focus {
        outline: none;
    }
`

export const Loading = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: ${colors.darkGreen};
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 13px;
    z-index: 10;

    img {
        width: 90px;
        display: block;
        margin: 0 auto;
        height: auto;
    }

    ${({ $mobile }) =>
        $mobile &&
        `
        top: 10%;
        transform: translate(-50%, -50%);
    `}
`

export const Content = styled(Container)`
    min-height: 500px;
    padding-top: 50px;
    flex-direction: column;
    align-items: center;
    display: flex;

    ${({ $mobile }) =>
        $mobile &&
        `
        padding-top: 20px;
        padding-left: 0 !important;
        padding-right: 0 !important;
        padding-bottom: 0;
        max-width: 100% !important;
    `}

    @media (max-width: 1200px) {
        padding-top: 40px;
        padding-left: 0 !important;
        padding-right: 0 !important;
        padding-bottom: 0;
        max-width: 100% !important;
    }
`

export const Title = styled.div`
    font-size: 20px;
    font-weight: 500;
    color: #008060;
    text-align: center;
    display: inline-block;
    padding: 10px;
    background-color: ${colors.smoothGray};
    margin-bottom: 15px;

    & strong {
        text-transform: uppercase;
        font-size: 19px;
        font-weight: 900;
    }

    ${({ $mobile }) =>
        $mobile &&
        `
        padding-bottom: 0;
        margin-bottom: 0;
    `}
`

export const TitleMobileOnly = styled.div`
    font-size: 18px;
    font-weight: 300;
    color: #008060;
    text-align: center;
    display: none;
    background-color: ${colors.smoothGray};
    padding-bottom: 0;
    margin-bottom: 0;
    line-height: 1.3;

    & strong {
        text-transform: uppercase;
        font-size: 16px;
        font-weight: 900;
    }

    ${mobile(`
        display: inline-block
    `)}
`

export const List = styled.div`
    width: 95%;
    min-height: 450px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 0 0 40px 0;
    position: relative;

    .slick-slide img {
        display: inline;
    }

    .slick-arrow {
        width: 40px;
        height: 40px;

        &.slick-prev {
            left: -20px;
            z-index: 1;
        }
        &.slick-next {
            right: -20px;
            z-index: 1;
        }
    }

    ${({ $mobile }) =>
        $mobile &&
        `
        width: 100%;
        display: block;
        max-width: 1000px;
        margin-top: 0;

        .product-card {
            margin: 35px 1px 1px 1px;
        }

        .slick-arrow {

            &.slick-prev {
                left: 0;
                z-index: 1;
            }

            &.slick-next {
                right: 0;
                z-index: 1;
            }
        }
    `}

    ${({ $mobile, $main }) =>
        $mobile &&
        $main &&
        `
        .slick-slider {
            margin-top: 0px !important;
        }
    `}

    @media (max-width: 1200px) {
        margin-top: 0;
    }
`
